<app-mini-navbar></app-mini-navbar>
<app-main-navbar></app-main-navbar>
<router-outlet></router-outlet>
<!-- <app-individual-listing></app-individual-listing> -->
<!-- <app-all-listings></app-all-listings> -->
<!-- <app-agent-profile-page></app-agent-profile-page> -->
<app-footer></app-footer>
